// eslint-disable-next-line
import tw from "twin.macro";
import React from "react";
//import all child components
import { Container } from "./ContactStyle";
import CompanyInfo from "./CompanyInfo";
import ContactForm from "./ContactForm";
import circle from "../../icons/circle.svg";

import Title from "../Title";

const Contact = () => {
  return (
    <div>
      <div
        style={{ backgroundImage: `url(${circle})` }}
        tw="bg-no-repeat bg-cover bg-center bg-gray-700 text-white min-h-screen grid place-items-center"
      >
        <Container tw="space-y-10  p-5">
          <Title title="Contact us" />
          <Container
            wrapper
            tw="bg-gradient-to-r from-gray-600  to-gray-700  text-white! rounded-3xl "
          >
            <div tw="background-color[#ff1c1c] p-5 rounded-2xl">
              <CompanyInfo />
            </div>
            <div tw="p-5">
              <ContactForm />
            </div>
          </Container>
        </Container>
      </div>
    </div>
  );
};

export default Contact;
